export const kMeanAbsoluteDeviationClass = "mean-absolute-deviation"
export const kMeanAbsoluteDeviationType = "Mean Absolute Deviation"
export const kMeanAbsoluteDeviationPrefix = "ADRN"
export const kMeanAbsoluteDeviationLabelKey = "DG.Inspector.graphPlottedMeanAbsDev"
export const kMeanAbsoluteDeviationValueTitleKey = "DG.PlottedAverageAdornment.madValueTitle"
